import script from "./FileInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileInput.vue?vue&type=script&lang=ts&setup=true"

import "./FileInput.vue?vue&type=style&index=0&id=64bedb34&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64bedb34"]])

export default __exports__